import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsConditions: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4">
      <div className="max-w-3xl mx-auto">
        <Link 
          to="/"
          className="inline-flex items-center gap-2 text-sky-500 hover:text-sky-600 font-medium mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Volver al inicio
        </Link>
        
        <div className="bg-white rounded-2xl shadow-lg border border-slate-100 p-8 md:p-12">
          <h1 className="text-3xl font-bold text-slate-900 mb-8">Términos y Condiciones</h1>
          
          <div className="prose prose-slate max-w-none">
            <p className="text-slate-600 mb-6">
              Última actualización: {new Date().toLocaleDateString('es-AR')}
            </p>
            
            <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">1. Aceptación de los Términos</h2>
            <p className="text-slate-600 mb-4">
              Al acceder y utilizar Clara AI ("el Servicio"), usted acepta estar sujeto a estos Términos y Condiciones. 
              Si no está de acuerdo con alguna parte de estos términos, no podrá acceder al Servicio.
            </p>
            
            <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">2. Descripción del Servicio</h2>
            <p className="text-slate-600 mb-4">
              Clara AI es una herramienta de inteligencia artificial diseñada para ayudar a humanizar comunicaciones 
              en el ámbito de la salud. El Servicio analiza textos y proporciona sugerencias para mejorar la claridad, 
              empatía y efectividad de las comunicaciones.
            </p>
            
            <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">3. Uso del Servicio</h2>
            <p className="text-slate-600 mb-4">
              El usuario se compromete a utilizar el Servicio de manera responsable y ética. No debe utilizarse para 
              generar contenido engañoso, fraudulento o que pueda causar daño a terceros.
            </p>
            
            <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">4. Limitación de Responsabilidad</h2>
            <p className="text-slate-600 mb-4">
              Las sugerencias proporcionadas por Clara AI son orientativas y no constituyen asesoramiento profesional. 
              El usuario es responsable de revisar y adaptar cualquier contenido generado antes de su uso.
            </p>
            
            <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">5. Propiedad Intelectual</h2>
            <p className="text-slate-600 mb-4">
              El Servicio y su contenido original son propiedad de Empatía. El usuario retiene los derechos sobre 
              los textos que ingresa al sistema.
            </p>
            
            <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">6. Modificaciones</h2>
            <p className="text-slate-600 mb-4">
              Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios entrarán 
              en vigor inmediatamente después de su publicación.
            </p>
            
            <h2 className="text-xl font-semibold text-slate-800 mt-8 mb-4">7. Contacto</h2>
            <p className="text-slate-600 mb-4">
              Para consultas sobre estos términos, puede contactarnos a través de{' '}
              <a href="https://masempatia.com" className="text-sky-500 hover:text-sky-600">masempatia.com</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
